export const SET_USER_ACCESSIBILITY = 'SET_USER_ACCESSIBILITY';
